<script setup>
import InputWithButton from "@/components/global-themed/inputs/InputWithButton.vue";
import {computed, ref} from "vue";

const emit = defineEmits(['close', 'locationAdded']);
const location = ref('');
const addLocation = (location) => {
  emit('locationAdded', location.charAt(0).toUpperCase() + location.slice(1));
}

const clear = () => {
  emit('close');
}

const showWarning = computed(() => /\d/.test(location.value)); // Check if the input contains a number
</script>

<template>
  <div class="tw-flex tw-flex-col tw-w-full tw-gap-4">
    <div class="tw-flex tw-items-center tw-justify-between">
      <span class="tw-text-lg tw-text-grey-dark tw-font-bold">
        Manually Input Location:
      </span>
      <svg-vue
        icon="icons/search-close"
        class="tw-w-7 tw-h-7 tw-text-grey tw-cursor-pointer"
        @click="clear"
      />
    </div>

    <InputWithButton
      v-model="location"
      placeholder="Enter a town or city"
      @submit="addLocation"
    />
    <small
      v-show="showWarning"
      class="tw-text-sm tw-text-orange -tw-mt-2 tw-self-start"
    >
      It looks like you’ve entered an address. Please only enter a city, town, or other location.
    </small>
  </div>
</template>
